import { useNavigate } from 'react-router-dom';

const MediaGridView = ({ collection, route }) => {
  
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3 md:gap-4 w-full">
      {collection.map((item) => (
        <div
          key={item.id}
          onClick={() => navigate(`/${route}/${item.id}`)}
          className="bg-charcoal p-2 sm:p-3 md:p-4 hover:bg-hover-charcoal rounded-lg cursor-pointer transition duration-200"
        >
          <div className="relative pb-[100%]">
            <img
              src={item.cover_art || item.image}
              alt={item.title}
              className="absolute top-0 left-0 w-full h-full rounded-lg object-cover"
            />
          </div>
          <div className="pt-[0.5rem]">
            <h1 className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold line-clamp-1">
              {item.title}
            </h1>
            <p className="text-xs font-medium line-clamp-1">
              {item.artist || item.genre}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MediaGridView;